export const ServerError = {
  Json: 0,
  R: 1,
  Python: 2
}
